var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.projectSelect && _vm.can([_vm.permissions.company.projects.index]))?_c('FormField',{attrs:{"dense":"","field":_vm.projectSelect}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }